<template>
  <el-dialog
    :visible.sync="show"
    style="margin-top: -5vh"
    width="1340px"
    :close-on-click-modal="false"
  >
    <iframe :src="url" frameborder="0" style="width: 1300px; height: 700px" />
  </el-dialog>
</template>

<script>
// import {cookieCacheGet} from '@/tool/cache.js';
import VueCookie from "vue-cookie";

export default {
  data() {
    return {
      show: false,
      url: "",
      row: {},
    };
  },
  methods: {
    calling(row) {
      this.row = row;
      this.$parent.post(this.$parent.urls.get_billing_detail).then((rs) => {
        if (!rs.url) {
          this.$message.error("未配置H5链接地址");
          return;
        }
        this.generateH5Url(rs.url);
        // rs.data.url;
      });
      this.show = true;
    },

    // url拼接参数
    generateH5Url(url) {
      const token = VueCookie.get("YISHOUSESS");
      const { supply_id: supplyId } = this.$parent.routeParams;
      const { is_dispense: isDispense } = this.$parent.routeParams;
      const num1 = this.row.total_price;
      const num2 = this.row.activity_fee;
      console.log(isDispense);
      const { goods_no: goodsNo } = this.row;
      const version = "ERP10.0.0";
      const env = "pc";
      const { planid } = this.$parent.routeParams;
      const woid = 0;
      this.url = `${url}/${token}/${supplyId}/${num1}/${num2}/${goodsNo}/${version}/${env}/${woid}/${planid}/${isDispense}`;
      console.log(this.url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/purchaseverify/components/BillingDetail.vue